// import * as types from "./featuresTypes";
import { FEATURES } from "~/utils/urlApi";
import * as api from "~/api";

// Check
export const requestAllFeatures = () => {
  return api.getHttpRequestAsync(FEATURES.REQUEST_ALL_FEATURES_URL);
};
